var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.474 3.83893C11.7701 4.13508 11.7701 4.61523 11.474 4.91138L6.224 10.1614C5.92785 10.4575 5.4477 10.4575 5.15155 10.1614L2.52655 7.53638C2.23041 7.24023 2.23041 6.76008 2.52655 6.46393C2.8227 6.16778 3.30285 6.16778 3.599 6.46393L5.68778 8.55271L10.4016 3.83893C10.6977 3.54278 11.1779 3.54278 11.474 3.83893Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCheck);
export default __webpack_public_path__ + "static/media/login-check.efd47c58558167939135b09438e6d7c8.svg";
export { ForwardRef as ReactComponent };